import { Controller } from "stimulus"
import './component.scss'

export default class extends Controller {
  static targets = ["root", "tableBody", "showMoreButton", "hiddenRow"]
  static classes = ["buttonClose", "rowHide"]
  static values = { rowsToAdd: { type: Number, default: 5 } }

  connect() {
    // 既存のjQueryイベントハンドラーがある場合は削除
    this.cleanup()
  }

  disconnect() {
    this.cleanup()
  }

  cleanup() {
    // 既存のjQueryイベントハンドラーを削除
    if (window.$ && window.$('.js-showMore-trigger').length > 0) {
      window.$('.js-showMore-trigger').off('click')
    }
  }

  showMore(event) {
    event.preventDefault()
    
    const hiddenRows = this.hiddenRowTargets.filter(row => 
      row.classList.contains(this.rowHideClass)
    )

    if (hiddenRows.length > 0) {
      // 指定された行数だけ表示
      const rowsToShow = hiddenRows.slice(0, this.rowsToAddValue)
      rowsToShow.forEach(row => {
        row.classList.remove(this.rowHideClass)
      })

      // 残りの非表示行をチェック
      const remainingHiddenRows = this.hiddenRowTargets.filter(row => 
        row.classList.contains(this.rowHideClass)
      )

      if (remainingHiddenRows.length === 0) {
        this.showMoreButtonTarget.classList.add(this.buttonCloseClass)
      }
    } else {
      // 全て非表示に戻す
      this.hiddenRowTargets.forEach(row => {
        row.classList.add(this.rowHideClass)
      })
      this.showMoreButtonTarget.classList.remove(this.buttonCloseClass)

      // テーブルの上までスクロールして戻す
      this.scrollToTop()
    }
  }

  scrollToTop() {
    const rootTop = this.rootTarget.offsetTop
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (rootTop < scrollTop) {
      const marginTop = 120
      window.scrollTo({ 
        top: rootTop - marginTop, 
        behavior: 'instant' 
      })
    }
  }
}
